<template>
  <div class="listNotation">
    <div class="screening">
      <el-popover placement="bottom-start" width="150" trigger="click">
        <el-checkbox-group v-model="source" size="medium" @change="sureSelect">
          <el-checkbox label="1">我的创建</el-checkbox>
          <el-checkbox label="2">我的修改</el-checkbox>
        </el-checkbox-group>
        <el-button slot="reference" class="screenSource" type="text">数据来源<i class="el-icon-arrow-down"></i></el-button>
      </el-popover>
      <el-button type="text" class="screenSource" @click="sortData">
        排序<i :class="[sortUp? 'el-icon-sort-up': 'el-icon-sort-down']"></i>
      </el-button>
      <el-popover placement="bottom-start" width="150" trigger="click">
        <el-checkbox-group v-model="queryForm.statusIdList" size="medium" @change="sureSelect">
          <el-checkbox v-for="item in dicList.statusList" :key="item.id" :label="item.id">
            {{ item.cnName }}
          </el-checkbox>
        </el-checkbox-group>
        <el-button slot="reference" class="screenSource" type="text">状态<i class="el-icon-arrow-down"></i></el-button>
      </el-popover>
      <el-button type="text" class="screenSource" @click="moreSelect">
        高级筛选<i :class="[selectBoolean?'el-icon-arrow-up':'el-icon-arrow-down']"></i>
      </el-button>
      <img v-if="markBoolean" src="./images/dwxs.png" class="markShow" alt="显隐锚点" title="点击隐藏全部" @click="changedwxs" />
      <img v-else src="./images/dwyc.png" class="markShow" alt="显隐锚点" title="点击显示全部" @click="changedwxs" />
    </div>
    <div v-if="type=='model' && !selectBoolean" class="logo">
      <span class="name">标签选择：</span>
      <span class="labelLogo" :class="{'active':labelIndexArray.includes(0) }" @click="choiceLabel(0)">全部</span>
      <span class="labelLogo" :class="{'active':labelIndexArray.includes(1)}" @click="choiceLabel(1)">2D</span>
      <span class="labelLogo" :class="{'active':labelIndexArray.includes(2)}" @click="choiceLabel(2)">3D</span>
      <span class="labelLogo" :class="{'active':labelIndexArray.includes(3) }" @click="choiceLabel(3)">整合模型</span>
    </div>
    <div v-if="!selectBoolean" class="search">
      <el-input v-model="keyword" size="small" placeholder="请输入问题描述" suffix-icon="el-icon-search" @input="sureSelect">
      </el-input>
      <i class="el-icon-refresh-right" @click="update"></i>
      <img src="./images/daochu.png" alt="导出问题列表" title="导出问题列表" @click="exportExcel" />
      <!-- <el-button v-if="!isHky" size="mini" type="danger" class="oaButton" style="margin: 0 5px; padding: 4px;" plain
        title="导出OA贯标表格" @click="exportOA">
        OA
      </el-button> -->
    </div>
    <!-- 问题列表 -->
    <div v-if="!selectBoolean" v-loading="loading" class="list" element-loading-text="数据获取中" >
      <ul class="infinite-list" style="overflow:auto" ref="infiniteList">
        <li v-for="item in nolist" :key="item.questionId" class="infinite-list-item" ref="listItems"
          :class="{'active':activeIndex == item.questionId}" @click="openDetail(item)">
          <div v-if="type == 'model'" class="top">
            <span v-for="(sou,index) in item.labelList" :key="index" class="labelLogo active">{{ sou }}</span>
            <span class="right">
              <!-- <img src="./images/dingwei.png" alt="定位" @click.stop="aim(item)"> -->
              <img src="./images/shanchu.png" alt="删除" @click.stop="delannotation(item.questionId)">
            </span>
          </div>
          <div v-if="type == 'model'" class="up">
            <!-- 处理问题 -->
            <el-dropdown trigger="hover" 
              :key="item.questionId" 
              :ref="`popover${item.questionId}`"
               @command="commandStatus"
              >
              <!-- <el-form :ref="`formstatus${item.questionId}`" :rules="statusRules" :model="formstatus" class="statusForm"
                size="small" label-position="top">
                <el-form-item label="问题状态:" prop="statusId">
                  <el-select v-model="formstatus.statusId" size="small" placeholder="请选择">
                    <el-option v-for="ele in dealList" :key="ele.id" :label="ele.cnName" :value="ele.id"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="说明:">
                  <el-input v-model="formstatus.content" placeholder="请输入说明" type="textarea" maxlength="200"
                    show-word-limit></el-input>
                </el-form-item>
                <el-form-item class="footer">
                  <el-button size="small" @click="closepop(item.questionId)">取 消</el-button>
                  <el-button size="small" type="primary" @click="changeStatus(item)">确 定</el-button>
                </el-form-item>
              </el-form> -->
              <span class="status" :class="{
                'status1': item.queStatus == '待修改',
                'status2': item.queStatus == '已修改',
                'status3': item.queStatus == '不修改',
                'status4': item.queStatus == '已销项',
              }">【{{ item.queStatus }}】</span>
              <el-dropdown-menu slot="dropdown" v-if="item.dealList && item.dealList.length > 0">
                 <el-dropdown-item 
                  v-for="ele in item.dealList" 
                  :key="ele.id" 
                  :value="ele.id" 
                  :command="{row:item, queStatusId: ele.id, queStatus: ele.cnName}">
                  {{ ele.cnName }}
                 </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <span class="checkContent" :title="item.checkContent">
              {{ item.checkContent }}
            </span>
          </div>
          <div v-else class="up">
            <!-- 处理问题 -->
            <el-dropdown 
              trigger="hover" 
              :key="item.questionId" 
              :ref="`popover${item.questionId}`"
               @command="commandStatus"
            >
              <!-- <el-form :ref="`formstatus${item.questionId}`" :rules="statusRules" :model="formstatus" class="statusForm"
                size="small" label-position="top">
                <el-form-item label="问题状态:" prop="statusId">
                  <el-select v-model="formstatus.statusId" size="small" placeholder="请选择">
                    <el-option v-for="ele in dealList" :key="ele.id" :label="ele.cnName" :value="ele.id"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="说明:">
                  <el-input v-model="formstatus.content" placeholder="请输入说明" type="textarea" maxlength="200"
                    show-word-limit></el-input>
                </el-form-item>
                <el-form-item class="footer">
                  <el-button size="small" @click="closepop(item.questionId)">取 消</el-button>
                  <el-button size="small" type="primary" @click="changeStatus(item)">确 定</el-button>
                </el-form-item>
              </el-form> -->
              <span class="status" :class="{
                'status1': item.queStatus == '待修改',
                'status2': item.queStatus == '已修改',
                'status3': item.queStatus == '不修改',
                'status4': item.queStatus == '已销项',
              }">【{{ item.queStatus }}】</span>
              <el-dropdown-menu slot="dropdown" v-if="item.dealList && item.dealList.length > 0">
                 <el-dropdown-item 
                  v-for="ele in item.dealList" 
                  :key="ele.id" 
                  :value="ele.id" 
                  :command="{row:item, queStatusId: ele.id, queStatus: ele.cnName}">
                  {{ ele.cnName }}
                 </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <span class="checkContent" :title="item.checkContent">
              {{ item.checkContent }}
            </span>
            <span class="right">
              <!-- <img v-if="type == 'dwg' || type == 'pdf'" src="./images/dingwei.png" alt="定位" @click.stop="aim(item)"> -->
              <img src="./images/shanchu.png" alt="删除" @click.stop="delannotation(item.questionId)">
            </span>
          </div>
          <div class="down">
            <span class="detailname">修改方:</span>
            <span :title="modifierNames(item)" class="modifierName">{{ modifierNames(item) }}</span>
            <span class="detailname">创建时间:</span>
            <span>
              {{ createDatechange(item.createDate) }}
            </span>
          </div>
        </li>
      </ul>
    </div>
    <!-- 高级查询 -->
    <div v-else class="select">
      <el-form ref="queryForm" :model="queryForm" label-position="top" label-width="86px" size="small">
        <el-form-item label="状态:">
          <el-checkbox-group v-model="queryForm.statusIdList">
            <el-checkbox v-for="(item, index) in dicList.statusList" :key="index" :label="item.id">
              {{ item.cnName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="意见类型:">
          <el-checkbox-group v-model="queryForm.qmTypeIdList">
            <el-checkbox v-for="(item, index) in dicList.checkTypeList" :key="index" :label="item.id">
              {{ item.cnName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="严重等级:">
          <el-checkbox-group v-model="queryForm.problemTypeIdList">
            <el-checkbox v-for="(item, index) in dicList.severityLevelList" :key="index" :label="item.id">
              {{ item.cnName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="创建人:" filterable>
          <el-select v-model="queryForm.createUserIdList" :popper-append-to-body="false" placeholder="请选择创建人" multiple
            filterable>
            <el-option v-for="(item, index) in dicList.createUserList" :key="index" :label="item.name"
              :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理人:" filterable>
          <el-select v-model="queryForm.modifierIdList" :popper-append-to-body="false" placeholder="请选择处理人" multiple
            filterable>
            <el-option v-for="(item, index) in dicList.modifierList" :key="index" :label="item.name"
              :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item v-if="!isHky&&dicList.specStageChildVos.some(ele=>ele.name=='阶段')" label="阶段:">
          <el-select v-model="queryForm.stageIdList" multiple placeholder="请选择阶段">
            <el-option v-for="item in dicList.specStageChildVos.find(ele=>ele.name=='阶段').optionalValues" :key="item.id"
              :label="item.cnName" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item v-if="dicList.specStageChildVos.some(ele=>ele.name=='专业')" label="专业:">
          <el-select v-model="queryForm.specIdList" multiple placeholder="请选择专业">
            <el-option v-for="item in dicList.specStageChildVos.find(ele=>ele.name=='专业').optionalValues" :key="item.id"
              :label="item.cnName" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="专业:">
          <el-select v-model="queryForm.multiSpecList" multiple placeholder="请选择专业">
            <el-option v-for="item in dicList.specList"
              :key="item.id" :label="item.cnName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item v-if="!isHky&&dicList.specStageChildVos.some(ele=>ele.name=='子项')" label="子项:">
          <el-select v-model="queryForm.stageChildIdList" multiple placeholder="请选择子项">
            <el-option v-for="item in dicList.specStageChildVos.find(ele=>ele.name=='子项').optionalValues" :key="item.id"
              :label="item.cnName" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="创建开始时间:">
          <el-date-picker ref="startDateRef" v-model="queryForm.startCreateTime" value-format="yyyy-MM-dd 00:00:00"
            type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="创建结束时间:">
          <el-date-picker ref="endDateRef" v-model="queryForm.endCreateTime" value-format="yyyy-MM-dd 00:00:00"
            type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="数据来源:">
          <el-select v-model="queryForm.sourceList" placeholder="请选择数据来源" multiple>
            <el-option v-for="(item, index) in dicList.problemSourceList" :key="index" :label="item.cnName"
              :value="item.cnName"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button size="small" @click="chongzhi">重置</el-button>
        <el-button size="small" title="应用" type="primary" @click="moreSureSelect">应用</el-button>
      </div>
    </div>
  </div>
</template>

<script>
const queryFormParams = () => ({
  statusIdList: [], // 状态
  qmTypeIdList: [], // 意见类型
  problemTypeIdList: [], // 严重等级
  createUserIdList: [], // 创建人
  modifierIdList: [], // 处理人
  stageIdList: [], // 阶段
  specIdList: [], // 专业
  multiSpecList: [], // 跨专业
  stageChildIdList: [], // 子项
  startCreateTime: "", // 创建开始时间
  endCreateTime: "", // 创建结束时间
  sourceList: [] // 数据来源
});
import mongeService from "@/CommonDP/mongeView/service/monge-service";
import { mapState } from "vuex";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import mongeCommon from "@/CommonDP/mongeView/common/mongeCommon";
import globalParams from "@/CommonDP/utils/globalParams";
import question from "@/xgzdService/question-service";

export default {
  props: {
    type: {
      type: String,
      default: ""
    },
    addType:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      prjID: "",
      fileId: "",
      source: [], // 来源
      keyword: "", // 问题描述
      dicList: {},
      sortUp: false, // 排序
      markBoolean: true, // 标记显隐
      selectBoolean: false, // 高级筛选
      labelIndexArray: [0],
      queryForm: queryFormParams(),
      dealList: [],
      formstatus: {
        // 修改问题状态
        statusId: "", // 问题id
        content: ""
      },
      visible: false,
      statusRules: {
        statusId: [{ required: true, message: "问题状态不可为空", trigger: "change" }]
      },
      pageNum: 1,
      pageSize: 20,
      totalPage: 1, // 总页数
      pageData: [], // 一页的数据
      nolist: [], // 查看总数
      loading: false,
      dataRow: "",
      activeIndex: "",
      mongeData: [],
      fileIdList: [],
      sharerUserId: '',
      shareId: "",
      isHky: false,
      flowInstanceId: "",
      scrollTop:0,
    };
  },
  computed: {
    ...mapState({
      currentUserID: (state) => state.user.userId
    }),
    refreshKey() {
      return mongeApp.refreshKey;
    },
    dwgdata() {
      return JSON.parse(mongeApp.map.fileInfo);
    },
    modelInfoData() {
      // 模型信息
      return JSON.parse(mongeApp.model.fileInfo);
    },
    spaceOfDwgData() {
      return mongeApp.map.spaceOfDwgData;
    },
    docmentData() {
      // 文件信息（非引擎）
      return JSON.parse(mongeApp.other.fileInfo);
    },
    queryParams() {
      const labelList = [];
      for (const ele of this.labelIndexArray) {
        if (ele === 1) {
          labelList.push("2D");
        } else if (ele === 2) {
          labelList.push("3D");
        } else if (ele === 3) {
          labelList.push("整合模型");
        }
      }
      let fileIdList = [];
      if (this.type === "model" && !!this.modelInfoData.fileObj) {
        fileIdList = this.fileIdList;
      }
      const params = {
        ...this.queryForm,
        keyword: this.keyword,
        sortType: this.sortUp ? 0 : 1, // 排序 排序方式 0升序 1降序
        currentUserScreenList: this.source,
        prjId: this.prjID,
        fileId: this.fileId,
        pageNum: this.pageNum,
        pageSize: 50000,
        labelList,
        fileIdList,
        currentUserId: this.sharerUserId,
        flowInstanceId: this.flowInstanceId,
        shareId: this.shareId
      };
      return params;
    },
    statusParams() {
      const { questionId, queStatusId, queStatus, toStatusId, toStatusName } = this.dataRow,
        params = {
          content: '',
          prjId: this.prjID,
          idList: [questionId],
          statusId: queStatusId,
          statusName: queStatus,
          toStatusId: toStatusId,
          toStatusName: toStatusName,
        };
      return params;
    },
    // 状态字典
    statusList() {
      return this.dicList?.statusList || [];
    }
  },
  watch: {
    refreshKey(newValue) {
      if (newValue) {
        this.update();
      }
    }
  },
  mounted() {
    this.isHky = globalParams.get("isHky");
    this.scrollTop=0
    this.init();
  },
  methods: {
    async init() {
      this.sharerUserId = this.$route.query.sharerId || "";
      this.flowInstanceId = this.$route.query.flowInstanceId || "";
      this.shareId = this.$route.query.i || "";
      if (this.type === "dwg") {
        this.prjID = this.dwgdata.prjId;
        this.fileId = this.dwgdata.fileId;
      } else if (this.type === "model") {
        if (this.modelInfoData.fileObj) {
          this.fileId = "";
          this.fileIdList = [];
          for (const item of this.modelInfoData.fileObj) {
            this.fileIdList.push(item.folderID);
          }
          this.prjID = this.modelInfoData.prjId;
        } else {
          this.fileId = this.modelInfoData.fileId;
          this.prjID = this.modelInfoData.prjId;
        }
      } else {
        this.fileId = this.docmentData.fileId;
        this.prjID = this.docmentData.prjId;
      }
      await this.queryDic();
      this.pageNum = 1;
      this.mongeData = [];
      this.nolist = [];
      await this.queryNotationList();
    },
    // 查询时候的字典
    async queryDic() {
      const res = await question.getFilterDic(this.prjID, this.sharerUserId, this.flowInstanceId);
      this.dicList = res.data || {};
      mongeMutations.setDicList(this.dicList);
      // this.$store.dispatch("setDicList", this.dicList)
    },
    moreSureSelect() {
      this.selectBoolean = !this.selectBoolean;
      this.sureSelect();
    },
    sureSelect() {
      this.pageNum = 1;
      this.nolist = [];
      if (this.type === "dwg" || this.type === "model") {
        mongeApiMlib.clearAnnotation();
      }
      this.queryNotationList();
    },
    // 查询列表
    async queryNotationList() {
      this.pageData = [];
      this.loading = true;
      try {
        const res = await mongeService.notationlist(this.queryParams);
        this.pageData = res.data;
        this.totalPage = res.totalPage;
        this.nolist = [...this.nolist, ...this.pageData];
        // this.$store.dispatch("setAnnotationList", this.nolist)
        this.nolist.forEach(item => {
            item.dealList = this.dealStatus(item);
          })
        this.loading = false;
        if (!this.$route.query.questionId) {
          await this.$nextTick();
          this.openAnnotation();
        }
        this.$nextTick(()=>{
          let element={}
          const index=res.data?.findIndex(ele=>ele.questionId===this.$route.query.questionId)
          console.log(this.$route.query.questionId,this.scrollTop);
          if(this.scrollTop){
            this.$refs.infiniteList.scrollTop=this.scrollTop
          }else if(this.addType){
            if(index>5){
              element = this.$refs.listItems[index-1];
            }else{
              element = this.$refs.listItems[index];
            }
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }
        })
      } catch (error) {
        this.loading = false;
      }
    },
    // 展示云线和锚点信息
    openAnnotation() {
      if (this.type === "dwg" || this.type === "model") {
        this.$emit("showAnnotation", this.pageData, this.statusList);
      }
    },
    // 刷新
    update() {
      this.pageNum = 1;
      this.nolist = [];
      if (this.type === "dwg" || this.type === "model") {
        mongeApiMlib.clearAnnotation();
      }
      this.queryNotationList();
    },
    // 排序
    sortData() {
      this.sortUp = !this.sortUp;
      this.pageNum = 1;
      if (this.type === "dwg" || this.type === "model") {
        mongeApiMlib.clearAnnotation();
      }
      this.nolist = [];
      this.queryNotationList();
    },
    // 高级筛选
    moreSelect() {
      this.selectBoolean = !this.selectBoolean;
    },
    // 标记显隐
    async changedwxs() {
      this.markBoolean = !this.markBoolean;
      if (this.type === "dwg" || this.type === "model") {
        mongeApiMlib.clearAnnotation();
      }
      if (this.markBoolean) {
        this.queryParams.pageNum = 0;
        this.queryParams.pageSize = 0;
        const res = await mongeService.notationlist(this.queryParams);
        const list = res.data || [];
        // this.$store.dispatch("setAnnotationList", list)
        if (this.type === "dwg" || this.type === "model") {
          mongeCommon.showAllAnnotation(list, this.statusList, this.type);
        }
      }
    },
    // 标签
    choiceLabel(index) {
      if (index === 0) {
        this.labelIndexArray = [0];
      } else {
        if (this.labelIndexArray.includes(index)) {
          this.labelIndexArray = this.labelIndexArray.filter((ele) => ele !== index);
        } else {
          this.labelIndexArray = [...this.labelIndexArray, index].filter((ele) => ele !== 0);
        }
      }
      this.pageNum = 1;
      if (this.type === "dwg" || this.type === "model") {
        mongeApiMlib.clearAnnotation();
      }
      this.nolist = [];
      this.queryNotationList();
    },
    modifierNames(row) {
      const names = [];
      if (row.modifierList && row.modifierList.length > 0) {
        row.modifierList.forEach((ele) => {
          names.push(ele.modifierName);
        });
      }
      return names.join(",");
    },
    // 导出问题列表
    exportExcel() {
      this.queryParams.pageNum = 0;
      this.queryParams.pageSize = 0;
      mongeService.drawingDrawingQuesExport(this.queryParams).then((response) => {
        const fileName = "批注列表.xlsx";
        if ("msSaveOrOpenBlob" in navigator) {
          // 兼容ie
          // let blob = response
          window.navigator.msSaveOrOpenBlob(response, fileName);
          return;
        } else {
          const link = document.createElement("a");
          const blob = response;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    },
    // 导出OA贯标表格
    async exportOA() {
      this.queryParams.pageNum = 0;
      this.queryParams.pageSize = 0;
      const res = await mongeService.exportOA(this.queryParams);
      const fileName = "设计校审记录单.xlsx";
      if ("msSaveOrOpenBlob" in navigator) {
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    // 打开详情
    openDetail(item) {
      this.scrollTop=this.$refs.infiniteList.scrollTop
      this.activeIndex = item.questionId;
      mongeMutations.setQuestionId(item.questionId);
      let obj = {};
      obj.pointContent = item.pointContent;
      obj.page = item.coordinate;
      this.$emit("getPosition", item.checkContent, obj);
      this.aim(item);
    },
    // 重置按钮
    chongzhi() {
      this.selectBoolean = !this.selectBoolean;
      this.queryForm = queryFormParams();
      this.pageNum = 1;
      if (this.type === "dwg" || this.type === "model") {
        mongeApiMlib.clearAnnotation();
      }
      this.nolist = [];
      this.queryNotationList();
    },
    // 修改单个问题状态
    dealStatus(item) {
      const { creatorId, queStatus, questionId, modifierList } = item;
      return this.dicList.statusList.filter(
        (ele) => ele.cnName !== queStatus
      );

      this.formstatus.statusId = "";
      this.formstatus.content = "";
      // this.$refs[`popover${questionId}`][0].showPopper = true;
      // this.$refs[`formstatus${questionId}`][0].resetFields();
      if (creatorId === this.currentUserID && modifierList.some((ele) => ele.modifierId === this.currentUserID)) {
        // 同一个人
        if (queStatus === this.statusList[0].cnName) {
          this.dealList = this.dicList.statusList.filter((ele) => ele.cnName === this.statusList[1].cnName || ele.cnName === this.statusList[2].cnName);
        } else if (queStatus === this.statusList[1].cnName) {
          this.dealList = this.dicList.statusList.filter(
            (ele) => ele.cnName === this.statusList[2].cnName || ele.cnName === this.statusList[0].cnName || ele.cnName === this.statusList[3].cnName
          );
        } else if (queStatus === this.statusList[2].cnName) {
          this.dealList = this.dicList.statusList.filter((ele) => ele.cnName === this.statusList[0].cnName || ele.cnName === this.statusList[3].cnName);
        } else if (queStatus === this.statusList[3].cnName) {
          this.dealList = this.dicList.statusList.filter((ele) => ele.cnName === this.statusList[0].cnName || ele.cnName === this.statusList[2].cnName);
        }
      } else {
        // 创建人
        if (creatorId === this.currentUserID) {
          if (queStatus === this.statusList[0].cnName) {
            this.dealList = this.dicList.statusList.filter((ele) => ele.cnName === this.statusList[2].cnName);
          } else if (queStatus === this.statusList[1].cnName) {
            this.dealList = this.dicList.statusList.filter(
              (ele) => ele.cnName === this.statusList[2].cnName || ele.cnName === this.statusList[0].cnName || ele.cnName === this.statusList[3].cnName
            );
          } else if (queStatus === this.statusList[2].cnName) {
            this.dealList = this.dicList.statusList.filter((ele) => ele.cnName === this.statusList[0].cnName);
          } else if (queStatus === this.statusList[3].cnName) {
            this.dealList = this.dicList.statusList.filter((ele) => ele.cnName === this.statusList[0].cnName || ele.cnName === this.statusList[2].cnName);
          }
        } else if (modifierList.some((ele) => ele.modifierId === this.currentUserID)) {
          // 处理人
          if (queStatus === this.statusList[0].cnName) {
            this.dealList = this.dicList.statusList.filter((ele) => ele.cnName === this.statusList[1].cnName || ele.cnName === this.statusList[2].cnName);
          } else if (queStatus === this.statusList[1].cnName) {
            this.dealList = this.dicList.statusList.filter((ele) => ele.cnName === this.statusList[0].cnName || ele.cnName === this.statusList[2].cnName);
          } else if (queStatus === this.statusList[2].cnName) {
            this.dealList = this.dicList.statusList.filter((ele) => ele.cnName === this.statusList[0].cnName);
          } else if (queStatus === this.statusList[3].cnName) {
            this.dealList = this.dicList.statusList.filter((ele) => ele.cnName === this.statusList[2].cnName);
          }
        } else {
          this.$refs[`popover${questionId}`][0].showPopper = false;
          this.$message.warning("很抱歉,仅问题创建人或者问题处理人有修改问题状态的权限");
        }
      }
    },
    closepop(id) {
      this.$refs[`popover${id}`][0].showPopper = false;
    },
    // 删除单个批注
    delannotation(id) {
      this.$confirm("是否删除当前批注?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const ids = [];
          ids.push(id);
          await mongeService.drawingQuestionDelete(ids);
          this.$message({ type: "success", message: "删除成功!" });
          this.pageNum = 1;
          this.nolist = [];
          if (this.type === "dwg" || this.type === "model") {
            mongeApiMlib.clearAnnotation();
          }
          this.queryNotationList();
        })
        .catch(() => {
          // this.$message({ type: "info", message: err.message || "已取消" });
        });
    },
    async aim(item) {
      if (this.type === "dwg" || this.type === "model") {
        // 图纸定位
        mongeCommon.fitToQs(item, this.statusList, this.type);
      } else if (this.type === "pdf") {
        this.$emit("fileaAim", item);
      }
    },
    async changeStatus(row) {
      this.dataRow = row;
      this.$refs[`formstatus${row.questionId}`][0].validate(async (valid) => {
        if (valid) {
          try {
            const res = await mongeService.drawingannotationupdateStatus(this.statusParams);
            if (res.result === "0") {
              this.$message.success("修改成功");
              this.$refs[`popover${row.questionId}`][0].showPopper = false;
              this.formstatus.statusId = "";
              this.formstatus.content = "";
              this.nolist = [];
              this.queryNotationList();
              this.isRead = true;
            }
          } catch (error) {
            this.$refs[`popover${row.questionId}`][0].showPopper = false;
          }
        }
      });
    },
    createDatechange(item) {
      const time = item.split(" ");
      return time[0];
    },
    async commandStatus({row,queStatusId, queStatus}) {
      this.dataRow = row;
      this.dataRow.toStatusId = queStatusId;
      this.dataRow.toStatusName = queStatus;
      const res = await question.drawingannotationupdateStatus(
              this.statusParams
      );
      if (res.result == "0") {
              this.$message.success("修改成功");
              this.formstatus.statusId = "";
              this.formstatus.content = "";
              this.nolist = [];
              this.queryNotationList();
              this.isRead = true;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.listNotation {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  .labelLogo {
    border: 0.6px solid #7a87a5;
    box-sizing: border-box;
    color: #606266;
    cursor: pointer;
    border-radius: 18px;
    font-size: 14px;
    line-height: 20px;
    padding: 0 4px;
    margin-right: 5px;
  }
  .labelLogo:hover {
    border: 0.6px solid var(--theme-color);
  }
  .labelLogo.active {
    border: 0.6px solid var(--theme-color);
    color: var(--theme-color);
  }
  // overflow-y: auto;
  .screening {
    width: 100%;
    height: 30px;
    padding: 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .screenSource {
      color: #606266;
      padding: 0 !important;
      margin-right: 8px;
      font-size: 14px;
      /deep/span {
        font-size: 14px;
      }
    }
    .markShow {
      cursor: pointer;
    }
  }
  .logo {
    width: 100%;
    height: 30px;
    padding: 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .name {
      font-size: 14px;
      line-height: 30px;
      user-select: none;
      color: #606266;
    }
  }
  .search {
    width: 100%;
    height: 40px;
    padding: 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    i {
      font-size: 23px;
      color: #8692b0;
      margin-left: 4px;
      cursor: pointer;
    }
    img {
      margin-left: 4px;
      cursor: pointer;
    }
  }
  .list {
    border-top: 1px solid rgb(212, 217, 236);
    width: 100%;
    height: calc(100% - 90px);
    padding: 10px 0 10px 10px;
    .infinite-list {
      width: 100%;
      height: 100%;
      padding-right: 10px;
      .infinite-list-item {
        width: 100%;
        min-height: 76px;
        border-bottom: 1px solid rgb(212, 217, 236);
        border-radius: 4px;
        padding: 0 5px;
      }
      .active {
        background: #f3f6ff;
      }
      .infinite-list-item:hover {
        background: #f3f6ff;
      }
      .up {
        width: 100%;
        height: 38px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .status {
          font-size: 14px;
          cursor: pointer;
        }
        .status1{
          color:#eb5757;
        }
        .status2{
          color:#eac100;
        }
        .status3{
          color:#8b8888;
        }
        .status4{
          color:#00B632;
        }
        .checkContent {
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          vertical-align: top;
          width: calc(100% - 120px);
          user-select: none;
        }
        .right {
          margin-left: auto;
          display: flex;
          flex-direction: row;
          img {
            margin-right: 5px;
            cursor: pointer;
          }
        }
      }
      .top {
        width: 100%;
        // height: 20px;
        padding-top: 10px;
        padding-left: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .right {
          margin-left: auto;
          display: flex;
          flex-direction: row;
          img {
            margin-right: 5px;
            cursor: pointer;
          }
        }
      }
      .down {
        width: 100%;
        height: 38px;
        display: flex;
        flex-direction: row;
        align-items: center;
        span {
          font-size: 14px;
          line-height: 18px;
        }
        .detailname {
          color: #606266;
          margin-right: 5px;
          user-select: none;
        }
        .modifierName {
          overflow: hidden;
          text-overflow: ellipsis;
          user-select: none;
          white-space: nowrap;
          width: calc(100% - 220px);
          vertical-align: top;
          margin-right: 10px;
        }
      }
    }
    // overflow-y: auto;
  }
  .select {
    border-top: 1px solid rgb(212, 217, 236);
    width: 100%;
    padding-left: 5px;
    height: calc(100% - 30px);
    .el-form {
      padding: 10px 5px 10px 0;
      width: 100%;
      height: calc(100% - 50px);
      overflow-y: auto;
    }
    .footer {
      width: 100%;
      height: 50px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      padding-right: 20px;
    }

    /deep/.el-checkbox {
      margin-right: 5px;
    }
    /deep/.el-select,
    .el-date-editor {
      width: 100%;
    }
    /deep/.el-form-item {
      margin-bottom: 10px;
    }
  }
}

.oaButton:focus {
  background: #ffffff !important;
  border-color: #f56c6c !important;
  color: #f56c6c !important;
}
// .popSource{
//    /deep/.el-checkbox{
//       padding: 8px 0;
//     }
// }
</style>
